import React, { useRef } from 'react'
import Header from '../components/Header/Header'
import MainSlider from '../components/MainSlider/MainSlider'
import Footer from '../components/Footer/Footer'
import AboutUs from '../components/Section04/AboutUs'
import Features from '../components/Features/Features'
import Benefit from '../components/Benefits/Benefit'
import HowItWork from '../components/HowItWork/HowItWork'
import Faq from '../components/Faqs/Faq'
import ContactUs from '../components/ContactUs/ContactUs'
import SalesProblemSection from '../components/SalesProblem/SalesProblemSection'


const LandingPage = () => {
  const aboutUsRef = useRef(null);
  const featureRef = useRef(null);
  const howItWorksRef = useRef(null);
  const faqRef = useRef(null);
  const contactusRef = useRef(null);

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);


  const scrollToAboutUs = (e) => {
    e.preventDefault();
    scrollToRef(aboutUsRef);
  };

  const scrollToFeature = (e) => {
    e.preventDefault();
    scrollToRef(featureRef);
  };

  const scrollToHowItWorks = (e) => {
    e.preventDefault();
    scrollToRef(howItWorksRef);
  };

  const scrollToFAQ = (e) => {
    e.preventDefault();
    scrollToRef(faqRef);
  };

  const scrollToContactUs = (e) => {
    e.preventDefault();
    scrollToRef(contactusRef);
  };

  return (
    <div>
      <Header scrollToAboutUs={scrollToAboutUs} scrollToFeature={scrollToFeature} scrollToHowItWorks={scrollToHowItWorks} scrollToFAQ={scrollToFAQ} scrollToContactUs={scrollToContactUs}/>
      <MainSlider  scrollToContactUs={scrollToContactUs}/>
      <SalesProblemSection/>
      <AboutUs ref={aboutUsRef} />
      <Features ref={featureRef} />
      <Benefit />
      <HowItWork ref={howItWorksRef} />
      {/* <Feature3DX/> */}
      {/* <SubscriptionPlan /> */}
      <Faq ref={faqRef} scrollToContactUs={scrollToContactUs} />
      <div ref={contactusRef}><ContactUs /></div>
      <Footer scrollToAboutUs={scrollToAboutUs} scrollToFeature={scrollToFeature} scrollToHowItWorks={scrollToHowItWorks} scrollToFAQ={scrollToFAQ} scrollToContactUs={scrollToContactUs}/>
    </div>
  )
}

export default LandingPage
